import PropTypes from 'prop-types';
import {ButtonGroup} from '@/components/atoms';
import {PageHeader} from '@/components/molecules';
import './perfectStorePreview.scss';

/**
 * Preview chrome: title (PageHeader) then last-updated + Duplicate/Download
 * ButtonGroup (same pattern as Activity/Rewards review + SaveCancelFooter).
 */
const PerfectStorePreviewHeader = ({
  name,
  lastUpdatedLabel,
  onDuplicate,
  onDownload,
  isDuplicateEnabled = false,
  isDownloadEnabled = false
}) => {
  const actionItems = [
    {
      icon: 'content_copy',
      label: 'Duplicate',
      onClick: onDuplicate,
      disabled: !isDuplicateEnabled
    },
    {
      icon: 'download',
      label: 'Download',
      onClick: onDownload,
      disabled: !isDownloadEnabled
    }
  ];

  return (
    <div
      className='perfect-store-preview-header'
      data-testid='perfect-store-preview-header'>
      <PageHeader
        title={name || 'Perfect Store'}
        wrapperClassName='mb-3 mt-0'
      />
      <div className='perfect-store-preview-header__action-bar'>
        {lastUpdatedLabel ? (
          <span
            className='perfect-store-preview-header__updated'
            data-testid='perfect-store-preview-last-updated'>
            {lastUpdatedLabel}
          </span>
        ) : (
          <span className='perfect-store-preview-header__updated' />
        )}
        <div className='perfect-store-preview-header__actions'>
          <ButtonGroup
            id='perfect-store-preview-actions'
            uiSchema={{items: actionItems}}
          />
        </div>
      </div>
    </div>
  );
};

PerfectStorePreviewHeader.propTypes = {
  name: PropTypes.string,
  lastUpdatedLabel: PropTypes.string,
  onDuplicate: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  isDuplicateEnabled: PropTypes.bool,
  isDownloadEnabled: PropTypes.bool
};

export default PerfectStorePreviewHeader;
